import styled from 'styled-components';

export const Button = styled.div`
  border: none;
  cursor: pointer;
  margin-right: 7px;
  background: none;
  font-size: 16px;
  font-weight: 400;
  color: #fff;
`;
export const Text = styled.p`
  font-weight: ${props => (props.bold ? '600' : props.fontWeight || '400')};
  font-size: 16px;
  display: inline;
  letter-spacing: -0.2px;
  color: ${props => props.color};
`;
export const NavbarPopup = styled.div`
  background: rgb(75, 40, 109);
  padding: 10px;
`;
export const Heading = styled.h2`
  font-size: 24px;
  font-weight: 500;
  color: #fff;
`;
export const Backdrop = styled.div`
  overflow: scroll;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999;
  text-align: left;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const ModalMain = styled.div`
  margin: 0 auto;

  height: auto;
  width: 100vw;
  border-radius: 0.25rem;
  box-shadow: rgb(0 0 0 / 20%) 0px 0px 16px 0px;
  z-index: 2000;
  background-color: rgb(255, 255, 255);
  position: relative;
  left: 0;
`;

export const ModalInner = styled.div`
  background-color: white;
  display: flex;
  flex-flow: column;
  -webkit-box-pack: justify;
  justify-content: space-between;
  height: 75%;
  width: 67%;
  margin-left: 17%;
  margin-top: 4.5%;
  max-height: 80% !important;
  overflow: scroll;
  position: fixed;
`;

export const ModalMessageMain = styled.div`
  width: 100%;
  margin: 0 auto;
  border: 1px solid rgb(227, 227, 227);
  box-shadow: rgb(227 227 227) 1px 1px 9px 4px;
  overflow: scroll;
`;

export const ModalCancel = styled.div`
  float: right;
  padding: 8px 8px;
  position: absolute;
  right: 0%;
  top: 0%;
  z-index: 2;
`;

export const ModalHeading = styled.div`
  overflow-wrap: break-word;
  color: rgb(42, 44, 46);
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.4;
  letter-spacing: -0.6px;
  margin-bottom: 1rem;
  \position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
`;

export const FieldWrapper = styled.div`
  margin: 1em 0;
`;

export const OrderHistoryMain = styled.div`
  padding: 1rem;
  margin-top: 1rem;
  border: 1px solid #d8d8d8;
`;

export const OrderHistoryDate = styled.div`
  font-size: 1.2em;
  font-weight: 700;
  margin: 0.5rem 0;
  border-bottom: 1px solid #d8d8d8;
  padding: 0.5rem 0;
`;

export const OrderHistoryDataMain = styled.div`
  display: flex;
  padding: 0.25rem 0;
`;

export const OrderHistoryTimestamp = styled.div`
  margin-right: 5rem;
  color: #71757b;
  font-size: 14px;
  font-weight: 700;
`;

export const OrderHistoryAction = styled.div`
  font-size: 14px;
  font-weight: 500;
`;

export const CommentMain = styled.div`
  border: 1px solid #d8d8d8;
`;

export const CommentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  background: #f8f8f8;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid #d8d8d8;
`;

export const CommenterName = styled.p`
  font-weight: 600;
  font-size: 15px;
`;

export const CommentDate = styled.p`
  font-weight: 600;
  font-size: 15px;
`;

export const CommentBody = styled.p`
  padding: 1rem;
`;

export const SummaryRow = styled.div`
  border: 1px solid rgb(234, 234, 234);
  border-radius: 5px;
  margin-top: 0.5rem;
  display: grid;
  grid-template-columns: 1fr 5fr;
  font-size: 14px;
`;

export const SummaryCol = styled.div`
  color: rgb(171, 171, 171);
  // width: 250px;
  padding: 10px;
  float: left;
  background-color: rgb(247, 247, 248);
  display: flex;
  alignitems: center;
`;
